exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-error-display {\n  background-color: #F8D9D9;\n  color: #CC0000;\n  padding: 20px;\n  border-bottom: 1px solid #CC0000;\n  text-align: center; }\n\n.form-display {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 62px);\n  flex-direction: column;\n  margin: -20px; }\n  .form-display.has-page-title {\n    min-height: calc(100vh - 62px  - 68px);\n    margin-top: 0px; }\n\n.form-actions-display {\n  margin: auto 0 0; }\n  .form-actions-display #close {\n    border: 1px solid white; }\n\n@media (max-width: 768px) {\n  .form-display {\n    min-height: calc(100vh - 42px); }\n    .form-display.has-page-title {\n      min-height: calc(100vh - 42px - 68px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/touchpoints/form.scss
// module id = 1424
// module chunks = 0